import * as styles from './PlanMobile.css'

export function PlanMobile() {
  return (
    <a href={`/LIAN_Ne26_Webseite_Plan_A3_WEB.pdf`} target="_blank" rel="noreferrer">
      <img src="/LIAN_Ne26_Webseite_Plan.svg" alt="Hallenplan 2026" width="800" height="auto" css={styles.image} />
    </a>
  )
}
